import { makeVar } from 'src/utils/makeVar.utils';

export const {
  hook: useSettingsFeedbackLastTab,
  get: getSettingsFeedbackLastTab,
  set: setSettingsFeedbackLastTab,
} = makeVar<'docs' | 'quotes'>('docs');
